import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { IconComponent } from '../../atoms/icon/icon.component';

@Component({
  selector: 'ui-status-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  template: `
    <div
      class="flex flex-row items-center justify-between gap-2 w-full min-h-10 h-full px-4 py-4 leading-none rounded-lg border border-gray-300 text-neutral-8"
    >
      {{ label() }}
      <ui-icon class="text-md" [class]="class()" [icon]="icon()" />
    </div>
  `,
})
export class StatusCardComponent {
  label = input<string>();
  isValid = input<boolean | null>();
  icon = computed<string>(() => {
    const isValid = this.isValid();
    if (typeof isValid !== 'boolean') return 'minus-circle';
    if (isValid) return 'check-circle';
    return 'close-circle';
  });

  class = computed(() => {
    const isValid = this.isValid();
    if (typeof isValid !== 'boolean') return 'text-neutral-7';
    if (isValid) return 'text-green';
    return 'text-error';
  });
}
